import { render } from "./blog-two-grid-section.vue?vue&type=template&id=af9fdb5e&scoped=true"
import script from "./blog-two-grid-section.vue?vue&type=script&lang=js"
export * from "./blog-two-grid-section.vue?vue&type=script&lang=js"

import "./blog-two-grid-section.vue?vue&type=style&index=0&id=af9fdb5e&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af9fdb5e"]])

export default __exports__